import React from "react";
import cupLogo from "./../../assets/images/logos/cup-logo.svg";
import * as Styled from "./Style";

const GlobalNav = () => {
  return (
    <Styled.GlobalNavStyle id="global-nav">
      <img
        // src={cupLogo}
        src={`${cupLogo}`}
        alt=""
      />
    </Styled.GlobalNavStyle>
  );
};

export default GlobalNav;
